export default __webpack_public_path__ + "static/media/arrow-white.321d6ad1.svg";